import { AppState } from 'Store'

const selectGridLoading = (state: AppState) => state.modules.grid.loading

export const gridSelectors = {
	selectGridLoading,
}
